export const GET_HIREMEMO_REQUEST = "GET_HIREMEMO_REQUEST";
export const GET_HIREMEMO_SUCCESS = "GET_HIREMEMO_SUCCESS";
export const GET_HIREMEMO_FAIL = "GET_HIREMEMO_FAIL";

export const GET_HIREMEMOPDF_REQUEST = "GET_HIREMEMOPDF_REQUEST";
export const GET_HIREMEMOPDF_SUCCESS = "GET_HIREMEMOPDF_SUCCESS";
export const GET_HIREMEMOPDF_FAIL = "GET_HIREMEMOPDF_FAIL";

export const UPDATE_HIREMEMO_REQUEST = "UPDATE_HIREMEMO_REQUEST";
export const UPDATE_HIREMEMO_SUCCESS = "UPDATE_HIREMEMO_SUCCESS";
export const UPDATE_HIREMEMO_FAIL = "UPDATE_HIREMEMO_FAIL";

export const DELETE_HIREMEMO_REQUEST = "DELETE_HIREMEMO_REQUEST";
export const DELETE_HIREMEMO_SUCCESS = "DELETE_HIREMEMO_SUCCESS";
export const DELETE_HIREMEMO_FAIL = "DELETE_HIREMEMO_FAIL";

export const EXPORT_HIREMEMO_REQUEST = "EXPORT_HIREMEMO_REQUEST";
export const EXPORT_HIREMEMO_SUCCESS = "EXPORT_HIREMEMO_SUCCESS";
export const EXPORT_HIREMEMO_FAIL = "EXPORT_HIREMEMO_FAIL";